const routingConstants = {
  GET_ALL_ROUTES_START: "GET_ALL_ROUTES_START",
  GET_ALL_ROUTES_SUCCESS: "GET_ALL_ROUTES_SUCCESS",
  GET_ALL_ROUTES_FAILED: "GET_ALL_ROUTES_FAILED",
  ADD_ROUTE_START: "ADD_ROUTE_START",
  ADD_ROUTE_END: "ADD_ROUTE_END",
  ADD_ROUTE_FAILED: "ADD_ROUTE_FAILED",
  VIEW_ROUTE_START: "VIEW_ROUTE_START",
  VIEW_ROUTE_SUCCESS: "VIEW_ROUTE_SUCCESS",
  VIEW_ROUTE_FAILED: "VIEW_ROUTE_FAILED",
  EDIT_ROUTE_START: "EDIT_ROUTE_START",
  EDIT_ROUTE_END: "EDIT_ROUTE_END",
  EDIT_ROUTE_FAILED: "EDIT_ROUTE_FAILED",
  EDIT_ROUTE_SUCCESS: "EDIT_ROUTE_SUCCESS",
};

export default routingConstants;
